import axios from "../utils/axios";

export const fetchApplicationsSummary = async ({ queryKey }) => {
  const [, month, year] = queryKey;

  const res = await axios
    .get("/getApplicationStatisticsAllPortsAuthorities", {
      params: { month, year },
    })
    .catch((error) => {
      if (error.response) {
        console.log(error);
      }
    });
  return res.data;
};
